module.exports = __webpack_public_path__ + "img/sports-insurance-symbol.814ea4a6.svg";